import DateBox from 'devextreme-react/date-box';
import { LoadPanel } from 'devextreme-react/load-panel';
import { SelectBox } from 'devextreme-react/select-box';
import React from 'react';
import Modal from 'react-modal'; //npm install --save react-modal
import Swal from 'sweetalert2';
import { formatDate, getRequestParams } from '../../helpers/globalfunctions';
import { SendEmailComponent } from '../Shared/SendEmailComponent';
const position = { of: '#historydiv' };

export class RevenueProfitLossComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpenModal: false,
            isEmailSubmitted: false,
            isSubmited: false,
            loadPanelVisible: false,

            chkCustomerSelection: "1",
            dropdownCustomer: [],
            customerCode: '',

            chkCustomerTypeSelection: "1",
            dropdownCustomerType: [],
            customerTypeId: 0,

            chkAirlineSelection: "1",
            dropdownAirline: [],
            airlineId: 0,

            chkInvoiceSelection: "1",
            invoiceNumber: '',

            chkPeriodSelection: "1",
            startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
            endDate: new Date(),

            chkReportTypeSelection: "1",

            errors: {
                customerCode: '',
                customerTypeId: '',
                airlineId: '',
                invoiceNumber: '',
            }
        }

        this.getCustomer = this.getCustomer.bind(this);
        this.handleCustomerChange = this.handleCustomerChange.bind(this);
        this.handleCustomerSelectionChange = this.handleCustomerSelectionChange.bind(this);

        this.getAirline = this.getAirline.bind(this);
        this.handleAirlineChange = this.handleAirlineChange.bind(this);
        this.handleAirlineSelectionChange = this.handleAirlineSelectionChange.bind(this);

        this.getCustomerType = this.getCustomerType.bind(this);
        this.handleCustomerTypeChange = this.handleCustomerTypeChange.bind(this);
        this.handleCustomerTypeSelectionChange = this.handleCustomerTypeSelectionChange.bind(this);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleInvoiceSelectionChange = this.handleInvoiceSelectionChange.bind(this);

        this.handlePeriodSelectionChange = this.handlePeriodSelectionChange.bind(this);
        this.handleFromDateChanged = this.handleFromDateChanged.bind(this);
        this.handleToDateChanged = this.handleToDateChanged.bind(this);

        this.handleReportTypeSelectionChange = this.handleReportTypeSelectionChange.bind(this);

        this.downloadAccountPaymentTypeSummaryAsPdf = this.downloadAccountPaymentTypeSummaryAsPdf.bind(this);

        this.handleSearchAccountPaySummaryReportSubmit = this.handleSearchAccountPaySummaryReportSubmit.bind(this);
        this.handleClearSearch = this.handleClearSearch.bind(this);
    }

    showModal = async () => {
        this.setState({ isOpenModal: true });
    }
    handleOnAfterOpenModal = async () => {
        try {
            this.setState({ loadPanelVisible: true });
            await this.getCustomer();
            await this.getCustomerType();
            await this.getAirline();
        } catch (ex) {
        }
        this.setState({ loadPanelVisible: false });
    }
    handleOnCloseModal = async () => {

        this.setState({ isOpenModal: false });
        await this.handleClearSearch();
    }

    async getCustomer() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('account-api/customer-dropdown/', requestParams);
            const data = await response.json();
            this.setState({
                dropdownCustomer: data.customers,
            });

        } catch (e) {
        }
    }

    handleCustomerChange(selectedOption) {
        this.setState({
            customerCode: selectedOption.selectedItem != null ? selectedOption.selectedItem.code : '',
            errors: { ...this.state.errors, customerCode: '' },
        });
    }

    handleCustomerSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState({ chkCustomerSelection: value, customerCode: '', errors: { ...this.state.errors, customerCode: '' } });
    }

    async getCustomerType() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('customer-type-api/', requestParams);
            const data = await response.json();
            this.setState({
                dropdownCustomerType: data.customerType,
            });

        } catch (e) {
        }
    }

    handleCustomerTypeChange(selectedOption) {
        this.setState({
            customerTypeId: selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0,
            errors: { ...this.state.errors, customerTypeId: '' },
        });
    }

    handleCustomerTypeSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState({ chkCustomerTypeSelection: value, customerTypeId: '', errors: { ...this.state.errors, customerTypeId: '' } });
    }

    async getAirline() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('air-line-api/' + 0, requestParams);
            const data = await response.json();
            this.setState({
                dropdownAirline: data.airLine,
            });

        } catch (e) {
        }
    }

    handleAirlineChange(selectedOption) {
        this.setState({
            airlineId: selectedOption.selectedItem != null ? selectedOption.selectedItem.id : 0,
            errors: { ...this.state.errors, airlineId: '' },
        });
    }

    handleAirlineSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState({ chkAirlineSelection: value, customerTypeId: '', errors: { ...this.state.errors, airlineId: '' } });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name === "invoiceNumber") {
            const re = /^[0-9\b]+$/;
            if (event.target.value === '' || re.test(event.target.value)) {
                this.setState({ [name]: event.target.value })
            }
        } else {
            this.setState({
                [name]: value
            });
        }
    }

    handleInvoiceSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState({ chkInvoiceSelection: value, invoiceNumber: '', errors: { ...this.state.errors, invoiceNumber: '' } });
    }

    handlePeriodSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState({ chkPeriodSelection: value });
    }

    handleReportTypeSelectionChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;

        this.setState({ chkReportTypeSelection: value });
    }

    handleFromDateChanged(event) {
        let fromDateValue = formatDate(event.value, "MM/dd/yyyy");
        this.setState({ startDate: fromDateValue })
    }
    handleToDateChanged(event) {
        let toDateValue = formatDate(event.value, "MM/dd/yyyy");
        this.setState({ endDate: toDateValue })
    }


    handleSearchAccountPaySummaryReportSubmit(e) {
        e.preventDefault();
        if (this.handleValidation()) {
            this.downloadAccountPaymentTypeSummaryAsPdf();
        }
    }
    handleClearSearch() {
        this.setState({
            isSubmited: false,
            isEmailSubmitted: false,
            loadPanelVisible: false,

            chkCustomerSelection: "1",
            dropdownCustomer: [],
            customerCode: '',

            chkCustomerTypeSelection: "1",
            dropdownCustomerType: [],
            customerTypeId: 0,

            chkAirlineSelection: "1",
            dropdownAirline: [],
            airlineId: 0,

            chkInvoiceSelection: "1",
            invoiceNumber: '',

            chkPeriodSelection: "1",
            startDate: new Date(new Date().setDate(new Date().getDate() - 1)),
            endDate: new Date(),

            chkReportTypeSelection: "1",

            errors: {
                customerCode: '',
                customerTypeId: '',
                airlineId: '',
                invoiceNumber: '',
            }
        });
    }

    handleValidation() {
        const errors = { customerCode: '', customerTypeId: '', airlineId: '', invoiceNumber: '' };
        let formIsValid = true;

        if (this.state.chkCustomerSelection === "2" && this.state.customerCode === "") {
            formIsValid = false;
            errors.customerCode = "Please select customer.";
        }

        if (this.state.chkCustomerTypeSelection === "2" && !this.state.customerTypeId) {
            formIsValid = false;
            errors.customerTypeId = "Please select customer type.";
        }

        if (this.state.chkAirlineSelection === "2" && !this.state.airlineId) {
            formIsValid = false;
            errors.airlineId = "Please select airline.";
        }

        if (this.state.chkInvoiceSelection === "2" && this.state.invoiceNumber === "") {
            formIsValid = false;
            errors.invoiceNumber = "Please enter invoice number.";
        }

        this.setState({ errors });
        return formIsValid;
    }
    async downloadAccountPaymentTypeSummaryAsPdf() {
        try {
            this.setState({
                isSubmited: true,
            });
            let RptHead = "";
            let sCustomerType = "";
            let sCustomer = "";
            let sAirline = "";
            let sInvoice = "";
            let sDate = "";
            let fileName = "";

            const request = {};
            request.LocationId = Number(sessionStorage.getItem("session_locationId"));

            if (this.state.chkPeriodSelection === "2") {
                request.StartDate = formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01";
                request.EndDate = formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59";
                sDate = " From Date " + "  " + formatDate(this.state.startDate, "MM/dd/yyyy") + "  " + "  To Date " + formatDate(this.state.endDate, "MM/dd/yyyy");
            } else {
                request.StartDate = null;
                request.EndDate = null;
                sDate = "For All Date";
            }
            if (this.state.chkCustomerTypeSelection === "1") {
                sCustomerType = " For all Customer Type, ";
                request.CustomerType = "";
            } else {
                let customerType = this.state.dropdownCustomerType.find(opt => opt.id == this.state.customerTypeId);
                request.CustomerType = customerType.name;
                sCustomerType = "  " + "For Customer Type" + "  " + customerType.name + ",";
            }

            if (this.state.chkCustomerSelection === "1") {
                sCustomer = " For all Customer, ";
                request.AccountCode = "";
            } else {
                let customer = this.state.dropdownCustomer.find(opt => opt.code == this.state.customerCode);
                request.AccountCode = this.state.customerCode;
                sCustomer = "  " + "For Customer " + "  " + customer.fullName + ",";
            }

            if (this.state.chkAirlineSelection === "1") {
                sAirline = " For all Airline, ";
                request.AirlineName = "";
            } else {
                let customer = this.state.dropdownAirline.find(opt => opt.airLineId == this.state.airlineId);
                request.AirlineName = customer.airLineName;
                sAirline = "  " + "For Airline " + "  " + customer.airLineName + ",";
            }

            if (this.state.chkInvoiceSelection === "1") {
                sInvoice = " For all Invoice, ";
                request.InvoiceNo = 0;
            } else {
                request.InvoiceNo = parseInt(this.state.invoiceNumber);
                sInvoice = "  " + "For Invoice " + "  " + this.state.invoiceNumber + ",";
            }

            if (this.state.chkReportTypeSelection === "1") {
                fileName = "RevenueCommissionSummaryLocationWise";
            }
            else if (this.state.chkReportTypeSelection === "2") {
                fileName = "RevenueCommissionSummaryMonthWise";
            }
            else if (this.state.chkReportTypeSelection === "3") {
                fileName = "RevenueCommissionSummaryCustomerWise";
            }
            else {
                fileName = "RevenueCommissionSummaryCustomerMonthWise";
            }

            RptHead = RptHead + sCustomerType;
            RptHead = RptHead + sCustomer;
            RptHead = RptHead + sAirline;
            RptHead = RptHead + sInvoice;
            RptHead = RptHead + sDate;

            request.Header = RptHead;
            request.MethodName = "GetRevenueProfitLoss";

            request.ReportType = parseInt(this.state.chkReportTypeSelection);
            request.StartDate = formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01";
            request.EndDate = formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59";

            request.fileFormat = 'pdf';
            const requestParams = getRequestParams('POST', request);
            const response = await fetch('crystal-report-api', requestParams);
            const dataResponse = await response.json();
            this.setState({
                isSubmited: false,
            });

            let a = document.createElement('a');
            a.href = dataResponse.reportBase64String;
            a.download = fileName + '.pdf';

            a.click();
        } catch (e) {
            this.setState({
                isSubmited: false,
            });
        }
    }
    handleOnSendEmail = async (event) => {
        event.preventDefault();
        try {
            if (this.handleValidation()) {
                this.setState({ isEmailSubmitted: true });
                let RptHead = "";
                let sCustomerType = "";
                let sCustomer = "";
                let sAirline = "";
                let sInvoice = "";
                let sDate = "";
                let fileName = "";

                const request = {};
                request.LocationId = Number(sessionStorage.getItem("session_locationId"));

                if (this.state.chkPeriodSelection === "2") {
                    request.StartDate = formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01";
                    request.EndDate = formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59";
                    sDate = " From Date " + "  " + formatDate(this.state.startDate, "MM/dd/yyyy") + "  " + "  To Date " + formatDate(this.state.endDate, "MM/dd/yyyy");
                } else {
                    request.StartDate = null;
                    request.EndDate = null;
                    sDate = "For All Date";
                }
                if (this.state.chkCustomerTypeSelection === "1") {
                    sCustomerType = " For all Customer Type, ";
                    request.CustomerType = "";
                } else {
                    let customerType = this.state.dropdownCustomerType.find(opt => opt.id == this.state.customerTypeId);
                    request.CustomerType = customerType.name;
                    sCustomerType = "  " + "For Customer Type" + "  " + customerType.name + ",";
                }

                if (this.state.chkCustomerSelection === "1") {
                    sCustomer = " For all Customer, ";
                    request.AccountCode = "";
                } else {
                    let customer = this.state.dropdownCustomer.find(opt => opt.code == this.state.customerCode);
                    request.AccountCode = this.state.customerCode;
                    sCustomer = "  " + "For Customer " + "  " + customer.fullName + ",";
                }

                if (this.state.chkAirlineSelection === "1") {
                    sAirline = " For all Airline, ";
                    request.AirlineName = "";
                } else {
                    let customer = this.state.dropdownAirline.find(opt => opt.airLineId == this.state.airlineId);
                    request.AirlineName = customer.airLineName;
                    sAirline = "  " + "For Airline " + "  " + customer.airLineName + ",";
                }

                if (this.state.chkInvoiceSelection === "1") {
                    sInvoice = " For all Invoice, ";
                    request.InvoiceNo = 0;
                } else {
                    request.InvoiceNo = parseInt(this.state.invoiceNumber);
                    sInvoice = "  " + "For Invoice " + "  " + this.state.invoiceNumber + ",";
                }

                if (this.state.chkReportTypeSelection === "1") {
                    fileName = "RevenueCommissionSummaryLocationWise";
                }
                else if (this.state.chkReportTypeSelection === "2") {
                    fileName = "RevenueCommissionSummaryMonthWise";
                }
                else if (this.state.chkReportTypeSelection === "3") {
                    fileName = "RevenueCommissionSummaryCustomerWise";
                }
                else {
                    fileName = "RevenueCommissionSummaryCustomerMonthWise";
                }

                RptHead = RptHead + sCustomerType;
                RptHead = RptHead + sCustomer;
                RptHead = RptHead + sAirline;
                RptHead = RptHead + sInvoice;
                RptHead = RptHead + sDate;

                request.Header = RptHead;
                request.MethodName = "GetRevenueProfitLoss";

                request.ReportType = parseInt(this.state.chkReportTypeSelection);
                request.StartDate = formatDate(this.state.startDate, "MM/dd/yyyy") + " 00:00:01";
                request.EndDate = formatDate(this.state.endDate, "MM/dd/yyyy") + " 23:59:59";

                request.fileFormat = 'pdf';
                const requestParams = getRequestParams('POST', request);
                const response = await fetch('crystal-report-api', requestParams);
                const dataResponse = await response.json();
                this.setState({ isEmailSubmitted: false });
                let fileData = dataResponse.reportBase64String;
                if (fileData !== null && fileData !== '') {
                    let emailSubject = 'Revenue - Profit & Loss';
                    let attachments = [];
                    let file = new Object();
                    file.fileData = fileData;
                    file.fileName = fileName + '.pdf';
                    file.fileExtension = '.pdf';
                    attachments.push(file);
                    this.refs.sendEmailComponent.showModal('', '', emailSubject, '', attachments);
                }
                else {
                    Swal.fire({
                        allowOutsideClick: false,
                        showCloseButton: true,
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong! Unable to process the email request.',
                    })
                }
            }
        } catch (ex) {
        }
        this.setState({ isEmailSubmitted: false });
    }
    render() {
        return (
            <div>
                <Modal ariaHideApp={false}
                    isOpen={this.state.isOpenModal}
                    style={{ content: { width: '55%' } }}
                    className={"react-modal"}
                    onAfterOpen={this.handleOnAfterOpenModal}
                    onRequestClose={this.handleOnCloseModal}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal">
                    <form method="post" onSubmit={this.handleSearchAccountPaySummaryReportSubmit}
                        style={(this.state.isSubmited || this.state.isEmailSubmitted) ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                        <div className="modal-header">
                            <h6 className="modal-title">Revenue - Profit & Loss</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleOnCloseModal}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <div className="form-group">
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdAllCustomerType" value="1" checked={this.state.chkCustomerTypeSelection === "1"} onChange={this.handleCustomerTypeSelectionChange} />
                                            <label className="form-check-label">All Customer Type</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdSingleCustomerType" value="2" checked={this.state.chkCustomerTypeSelection === "2"} onChange={this.handleCustomerTypeSelectionChange} />
                                            <label className="form-check-label">Single</label>
                                        </span>
                                        <SelectBox
                                            dataSource={this.state.dropdownCustomerType.length > 0 ? this.state.dropdownCustomerType : []}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select customer type"
                                            name="customerTypeId"
                                            defaultValue={0}
                                            value={this.state.customerTypeId}
                                            displayExpr='name'
                                            valueExpr='id'
                                            onSelectionChanged={this.handleCustomerTypeChange}
                                            showClearButton={true}
                                            disabled={this.state.chkCustomerTypeSelection === "1"}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["customerTypeId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["customerTypeId"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <div className="form-group">
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdAllCustomer" value="1" checked={this.state.chkCustomerSelection === "1"} onChange={this.handleCustomerSelectionChange} />
                                            <label className="form-check-label">All Customer</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdSingleCustomer" value="2" checked={this.state.chkCustomerSelection === "2"} onChange={this.handleCustomerSelectionChange} />
                                            <label className="form-check-label">Single</label>
                                        </span>
                                        <SelectBox
                                            dataSource={this.state.dropdownCustomer.length > 0 ? this.state.dropdownCustomer : []}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select customer"
                                            name="customerCode"
                                            defaultValue={0}
                                            value={this.state.customerCode}
                                            displayExpr='fullName'
                                            valueExpr='code'
                                            onSelectionChanged={this.handleCustomerChange}
                                            showClearButton={true}
                                            disabled={this.state.chkCustomerSelection === "1"}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["customerCode"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["customerCode"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <div className="form-group">
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdAllAirline" value="1" checked={this.state.chkAirlineSelection === "1"} onChange={this.handleAirlineSelectionChange} />
                                            <label className="form-check-label">All Airline</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdSingleAirline" value="2" checked={this.state.chkAirlineSelection === "2"} onChange={this.handleAirlineSelectionChange} />
                                            <label className="form-check-label">Single Airline</label>
                                        </span>
                                        <SelectBox
                                            dataSource={this.state.dropdownAirline.length > 0 ? this.state.dropdownAirline : []}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select airline"
                                            name="airlineId"
                                            defaultValue={0}
                                            value={this.state.airlineId}
                                            displayExpr='airLineName'
                                            valueExpr='airLineId'
                                            onSelectionChanged={this.handleAirlineChange}
                                            showClearButton={true}
                                            disabled={this.state.chkAirlineSelection === "1"}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["airlineId"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["airlineId"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <div className="form-group">
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdAllInvoice" value="1" checked={this.state.chkInvoiceSelection === "1"} onChange={this.handleInvoiceSelectionChange} />
                                            <label className="form-check-label">All Invoice</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdSingleInvoice" value="2" checked={this.state.chkInvoiceSelection === "2"} onChange={this.handleInvoiceSelectionChange} />
                                            <label className="form-check-label">Single Invoice</label>
                                        </span>
                                        <div className="form-group">
                                            <input type="text" className="form-control form-control-sm" name="invoiceNumber" disabled={this.state.chkInvoiceSelection === "1"} maxLength="30" title="Enter invoice number" value={this.state.invoiceNumber} onChange={this.handleInputChange} placeholder="Enter invoice #" />
                                        </div>
                                        {this.state.errors["invoiceNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["invoiceNumber"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
                                    <div className="form-group">
                                        <label htmlFor="">&nbsp;</label>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdAllPeriod" value="1" checked={this.state.chkPeriodSelection === "1"} onChange={this.handlePeriodSelectionChange} />
                                            <label className="form-check-label">All Period</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdInRangePeriod" value="2" checked={this.state.chkPeriodSelection === "2"} onChange={this.handlePeriodSelectionChange} />
                                            <label className="form-check-label">In Range</label>
                                        </span>
                                        <DateBox type="date"
                                            className="form-control form-control-sm"
                                            name="fromDate"
                                            placeholder="mm/dd/yyyy"
                                            useMaskBehavior={true}
                                            defaultValue={this.state.startDate}
                                            value={this.state.startDate}
                                            onValueChanged={this.handleFromDateChanged}
                                            width="100%"
                                            disabled={this.state.chkPeriodSelection === "1"}
                                            acceptCustomValue={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <label><br /></label>
                                        <DateBox type="date"
                                            className="form-control form-control-sm"
                                            name="toDate"
                                            placeholder="mm/dd/yyyy"
                                            useMaskBehavior={true}
                                            defaultValue={this.state.endDate}
                                            value={this.state.endDate}
                                            onValueChanged={this.handleToDateChanged}
                                            width="100%"
                                            disabled={this.state.chkPeriodSelection === "1"}
                                            acceptCustomValue={false}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="form-group">
                                        <label htmlFor="">Report Type</label><br />
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdLocationWise" value="1" checked={this.state.chkReportTypeSelection === "1"} onChange={this.handleReportTypeSelectionChange} />
                                            <label className="form-check-label">Location Wise</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdMonthWise" value="2" checked={this.state.chkReportTypeSelection === "2"} onChange={this.handleReportTypeSelectionChange} />
                                            <label className="form-check-label">Month Wise</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdCustomerWise" value="3" checked={this.state.chkReportTypeSelection === "3"} onChange={this.handleReportTypeSelectionChange} />
                                            <label className="form-check-label">Customer Wise</label>
                                        </span>
                                        <span className="form-check">
                                            <input className="form-check-input" type="radio" name="rdCustomerMonthWise" value="4" checked={this.state.chkReportTypeSelection === "4"} onChange={this.handleReportTypeSelectionChange} />
                                            <label className="form-check-label">Customer Month Wise</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success btn-sm" onClick={this.handleOnSendEmail} >
                                {this.state.isEmailSubmitted && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isEmailSubmitted && <span title="Send Email"><i className="fas fa-envelope"></i> Send Email</span>}
                            </button>
                            <button type="button" className="btn btn-success btn-sm" title="Download" onClick={this.handleSearchAccountPaySummaryReportSubmit} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                                {this.state.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isSubmited && <span title="Download"><i className="fas fa-file-download"></i> Download</span>}
                            </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" title="Clear"
                                onClick={this.handleClearSearch}>
                                <i className="fas fa-eraser"></i> Clear
                                </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" title="Close"
                                onClick={this.handleOnCloseModal}>
                                <i className="fas fa-times"></i> Close
                                </button>
                        </div>
                    </form>
                </Modal>
                <SendEmailComponent ref="sendEmailComponent" />
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={position}
                    visible={this.state.loadPanelVisible}
                    showIndicator={true}
                    shading={false}
                    showPane={true}
                    closeOnOutsideClick={false}
                />
            </div >
        )
    }
}